<template>
  <div v-cloak>
    <!--设置value便于父组件与子组件通信-->
    <tabs v-model="activeName">
      <pane name="1"
            :label="this.$t('employee.employeeBasicInfo')">
        <div class="emp_info_cla panel_cla1"
             v-if="currentEmp">
          <ZkKvItem :label="this.$t('employee.employeeNo')">{{
            currentEmp.employeeNo
          }}</ZkKvItem>
          <ZkKvItem :label="this.$t('employee.formattedName')">{{
            currentEmp.formattedName
          }}</ZkKvItem>
          <ZkKvItem :label="this.$t('employee.email')">{{
            currentEmp.email | emailFormat
          }}</ZkKvItem>
          <ZkKvItem :label="this.$t('employee.phone')">{{
            currentEmp.phone | phoneFormat
          }}</ZkKvItem>
          <ZkKvItem :label="this.$t('employee.gender')">
            <ZkDictionaryValue :key="currentEmp.gender"
                               type="sex"
                               :value="currentEmp.gender"></ZkDictionaryValue>
          </ZkKvItem>
          <ZkKvItem :label="this.$t('employee.active')">
            <ZkDictionaryValue :key="currentEmp.active"
                               type="active"
                               :value="currentEmp.active"></ZkDictionaryValue>
          </ZkKvItem>

          <ZkKvItem :label="this.$t('employee.hireDate')">{{
            currentEmp.hireDate
          }}</ZkKvItem>
        </div>
      </pane>

      <pane name="2"
            :label="this.$t('employee.employeeAttInfo')">
        <div class="emp_info_cla"
             v-if="currentEmp">
          <el-form autocomplete="off"
                   size="mini"
                   label-position="right"
                   v-model="employeeAttInfo">
            <el-form-item :label="this.$t('employee.employeeNo')">{{ currentEmp.employeeNo }}
            </el-form-item>

            <el-form-item :label="this.$t('employee.formattedName')">{{ currentEmp.formattedName }}
            </el-form-item>

            <el-form-item :label="this.$t('employee.badgeNo')">
              <el-input v-model.trim="employeeAttInfo.badgeNo"
                        autocomplete="off"
                        name="badgeNo"
                        :placeholder="this.$t('employee.badgeNo')"></el-input>
            </el-form-item>

            <el-form-item :label="this.$t('employee.devicePassword')">
              <el-input type="password"
                        name="devicePassword"
                        v-model="employeeAttInfo.devicePassword"
                        autocomplete="new-password"
                        :placeholder="this.$t('employee.devicePassword')"></el-input>
            </el-form-item>

            <el-form-item :label="this.$t('employee.verifyingMode')">
              <el-select v-model="employeeAttInfo.deviceVerifyMode"
                         filterable
                         :placeholder="this.$t('employee.verifyingMode')">
                <el-option v-for="item in verifyintModel"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item :label="this.$t('employee.devicePermission')">
              <el-select v-model="employeeAttInfo.devicePermission"
                         filterable
                         :placeholder="this.$t('employee.devicePermission')">
                <el-option v-for="item in devicePermission"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item :label="this.$t('verifyintModel.FingerCount')">
              <!-- <el-input style="width:50px" disabled v-model="employeeAttInfo.FingerCount"></el-input> -->
              <i v-bind:class="{ active: employeeAttInfo.FingerCount > 0 }"
                 class="zk-icon-ic_zw-"></i>
              <el-button :disabled="employeeAttInfo.FingerCount === 0"
                         @click.stop="deleteBioTemplate('FingerCount')">{{ $t('common.delete') }}</el-button>
            </el-form-item>

            <el-form-item :label="this.$t('verifyintModel.BioDataCount')">
              <i v-bind:class="{ active: employeeAttInfo.BioDataCount > 0 }"
                 class="zk-zk-icon-ic_zw-ic_rl"></i>
              <!-- <el-input style="width:50px" disabled v-model="employeeAttInfo.BioDataCount"></el-input> -->
              <el-button :disabled="employeeAttInfo.BioDataCount === 0"
                         @click.stop="deleteBioTemplate('BioDataCount')">{{ $t('common.delete') }}</el-button>
            </el-form-item>

            <el-form-item :label="this.$t('verifyintModel.FaceCount')">
              <i v-bind:class="{ active: employeeAttInfo.FaceCount > 0 }"
                 class="zk-icon-nirFace"></i>
              <!-- <el-input style="width:50px" disabled v-model="employeeAttInfo.FaceCount"></el-input> -->
              <el-button :disabled="employeeAttInfo.FaceCount === 0"
                         @click.stop="deleteBioTemplate('FaceCount')">{{ $t('common.delete') }}</el-button>
            </el-form-item>
          </el-form>
          <div style="text-align: right; padding-right: 30px">
            <el-button v-if="this.employeeId"
                       @click.stop="savemployeeEnrollment"
                       type="primary">{{ $t('common.save') }}</el-button>
          </div>
        </div>
      </pane>
      <pane name="3"
            :label="this.$t('employee.assignment')">
        <div class="emp_info_cla">
          <div v-if="this.employeeId"
               class="header-button-bar">
            <el-button @click.stop="showBindDia"
                       v-if="currentEmp"
                       type="primary"
                       size="small">{{ this.$t('device.assignDevice') }}</el-button>
            <el-button @click.stop="ubBindEven"
                       v-if="currentEmp"
                       type="primary"
                       size="small"
                       :disabled="empBindList.length === 0">{{ this.$t('device.unBindBtn') }}</el-button>
          </div>

          <el-table @selection-change="changeUnBindSelection"
                    :data="empBindList"
                    border
                    style="width: 100%">
            <el-table-column type="selection"
                             width="55"></el-table-column>
            <el-table-column prop="devSn"
                             :label="this.$t('device.sn')"></el-table-column>
            <el-table-column prop="devAlias"
                             :label="this.$t('device.alias')"></el-table-column>
            <el-table-column prop="devStatus"
                             :label="this.$t('common.status')">
              <template slot-scope="scope">
                <deviceStatus :status="scope.row.devStatus===0?1:0"></deviceStatus>
              </template>
            </el-table-column>

            <el-table-column :label="this.$t('common.action')">
              <template slot-scope="scope">
                <el-tag class="action_btn"
                        @click="viewDevice(scope.row)"
                        type="success">view</el-tag>
                <el-tag class="action_btn"
                        @click="deleteDevice(scope.row)"
                        type="info">
                  <i class="el-icon-delete"></i>
                </el-tag>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </pane>
    </tabs>

    <el-dialog :append-to-body="true"
               :title="this.$t('device.selectDeivces')"
               :visible.sync="bindDialogTableVisible">
      <el-table max-height="300"
                :data="empUnBindList"
                @selection-change="handleSelectionChange">
        <el-table-column type="selection"
                         width="55"></el-table-column>
        <el-table-column prop="devSn"
                         :label="this.$t('device.sn')"></el-table-column>
        <el-table-column prop="devAlias"
                         :label="this.$t('device.alias')"></el-table-column>
        <el-table-column prop="devStatus"
                         :label="this.$t('common.status')">
          <template slot-scope="scope">
            <deviceStatus :status="scope.row.devStatus===0 ? 1:0"></deviceStatus>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click.stop="cancelBind">{{
          $t('common.cancel')
        }}</el-button>
        <el-button type="primary"
                   @click="submitBind">{{
          $t('common.confirm')
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as deviceApi from '@/services/deviceApi.js'

import * as employeeApi from '@/services/employeeApi.js'

export default {
  data () {
    return {
      activeName: '1',
      employeeId: '',
      bindDialogTableVisible: false,
      empBindList: [], // 已经绑定的设备列表
      empUnBindList: [], // 未绑定的设备列表
      multipleBindSelection: [], // 绑定的选中元素
      multipleUnbindSelection: [], // 解绑选中的元素
      employeeAttInfo: {
        BioDataCount: 0,
        FingerCount: 0,
        FaceCount: 0,
        devicePermission: 0,
        badgeNo: '',
        devicePassword: '',
        deviceVerifyMode: 0
      },
      verifyintModel: [],
      devicePermission: []
    }
  },
  props: {
    currentEmp: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  watch: {
    'currentEmp.id': {
      handler: function (val, oVal) {
        if (val) {
          this.employeeId = val
          this.getBindList()
          this.getEmployeeEnrollment()
        } else {
          this.employeeId = ''
          this.empBindList = [] // 已经绑定的设备列表
          this.empUnBindList = [] // 未绑定的设备列表
          this.multipleBindSelection = [] // 绑定的选中元素
          this.multipleUnbindSelection = [] // 解绑选中的元素
          this.employeeAttInfo.BioDataCount = 0
          this.employeeAttInfo.FingerCount = 0
          this.employeeAttInfo.FaceCount = 0
          this.employeeAttInfo.devicePermission = ''
          this.employeeAttInfo.badgeNo = ''
          this.employeeAttInfo.devicePassword = ''
          this.employeeAttInfo.deviceVerifyMode = ''
        }
      },
      deep: true
    }
  },

  mounted () {
    this.loadVerifyintModel()
    this.loadDevicePermission()
    this.getEmployeeEnrollment()
  },
  methods: {
    deleteBioTemplate (key) {
      let params = {
        employeeId: this.employeeId,
        key: key
      }
      this.$confirm(
        this.$t('device.deleteBioTemplate'),
        this.$t('common.warningNotice'),
        {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          employeeApi
            .deleteBioTemplate(params)
            .then((data) => {
              this.getEmployeeEnrollment()
            })
            .catch((e) => {
              this.errorMessage()
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('common.cancelOperation')
          })
        })
    },
    getEmployeeEnrollment () {
      if (!this.employeeId) {
        if (this.currentEmp && this.currentEmp.id) {
          this.employeeId = this.currentEmp.id
        } else {
          return false
        }
      }
      let params = {
        employeeId: this.employeeId
      }
      employeeApi
        .findEmployeeEnrollment(params)
        .then((data) => {
          if (data.code === '00000000') {
            let result = data.payload.results
            this.employeeAttInfo.BioDataCount = result.BioDataCount
            this.employeeAttInfo.FingerCount = result.FingerCount
            this.employeeAttInfo.FaceCount = result.FaceCount
            this.employeeAttInfo.devicePermission = result.devicePermission
            this.employeeAttInfo.badgeNo = result.cardNo
            this.employeeAttInfo.devicePassword = result.devicePassword
            this.employeeAttInfo.deviceVerifyMode = result.deviceVerifyMode
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch((e) => {
          this.errorMessage()
        })
    },
    loadDevicePermission () {
      employeeApi.getVerifyintModel(this).then((data) => {
        this.verifyintModel = data
      })
    },
    loadVerifyintModel () {
      employeeApi.getDevicePermission(this).then((data) => {
        this.devicePermission = data
      })
    },
    savemployeeEnrollment () {
      if (!this.employeeId) {
        if (this.currentEmp && this.currentEmp.id) {
          this.employeeId = this.currentEmp.id
        } else {
          return false
        }
      }
      let params = {
        devicePassword: this.employeeAttInfo.devicePassword,
        devicePermission: this.employeeAttInfo.devicePermission,
        deviceVerifyMode: this.employeeAttInfo.deviceVerifyMode,
        employeeId: this.employeeId,
        cardNo: this.employeeAttInfo.badgeNo
      }
      employeeApi
        .saveEmployeeEnrollment(params)
        .then((data) => {
          if (data.code === '00000000') {
            this.$message({
              message: this.$t('common.saveSucess'),
              type: 'success'
            })
            this.getEmployeeEnrollment()
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch((data) => {
          this.errorMessage(data.message)
        })
    },
    showBindDia () {
      this.getUnbindList()
      this.bindDialogTableVisible = true
    },
    changeUnBindSelection (val) {
      this.multipleUnbindSelection = val
    },
    handleSelectionChange (val) {
      this.multipleBindSelection = val
    },
    cancelBind () {
      // 取消绑定
      this.bindDialogTableVisible = false
    },
    ubBindEven () {
      // 批量解除绑定
      if (this.multipleUnbindSelection.length < 1) {
        this.errorMessage(this.$t('common.selectRecod'))
        return false
      }
      let deviceSn = this.multipleUnbindSelection.map((item) => {
        return item.devSn
      })
      let params = {
        deviceSn: deviceSn,
        employeeId: [this.employeeId]
      }
      this.setUnBindDevice(params)
    },
    submitBind () {
      if (!this.employeeId) {
        if (this.currentEmp && this.currentEmp.id) {
          this.employeeId = this.currentEmp.id
        } else {
          return false
        }
      }
      if (this.multipleBindSelection.length < 1) {
        this.errorMessage(this.$t('common.selectRecod'))
        return false
      }
      let deviceSn = this.multipleBindSelection.map((item) => {
        return item.devSn
      })
      let params = {
        deviceSn: deviceSn,
        employeeId: [this.employeeId]
      }
      // this.setBindDevice(params)
      deviceApi
        .setEmployeeBindDevices(params)
        .then((data) => {
          if (data.code === '00000000') {
            this.bindDialogTableVisible = false
            this.getBindList()
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch((data) => {
          this.errorMessage()
        })
    },
    getBindList () {
      if (!this.employeeId) {
        if (this.currentEmp && this.currentEmp.id) {
          this.employeeId = this.currentEmp.id
        } else {
          return false
        }
      }
      let params = {
        employeeId: this.employeeId
      }
      deviceApi
        .getEmployeeDeviceList(params)
        .then((data) => {
          if (data.code === '00000000') {
            this.empBindList = data.payload.results
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch((data) => {
          this.errorMessage()
        })
    },

    getUnbindList () {
      if (!this.employeeId) {
        if (this.currentEmp && this.currentEmp.id) {
          this.employeeId = this.currentEmp.id
        } else {
          return false
        }
      }
      let params = {
        employeeId: this.employeeId
      }
      deviceApi
        .getEmployeeUnBindDeviceList(params)
        .then((data) => {
          if (data.code === '00000000') {
            this.empUnBindList = data.payload.results
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch((data) => {
          this.errorMessage()
        })
    },
    setBindDevice (params) {
      this.$confirm(
        this.$t('device.setEmployeeBind'),
        this.$t('common.warningNotice'),
        {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          deviceApi
            .setEmployeeBindDevices(params)
            .then((data) => {
              if (data.code === '00000000') {
                this.bindDialogTableVisible = false
                this.getBindList()
              } else {
                this.errorMessage(data.message)
              }
            })
            .catch((data) => {
              this.errorMessage()
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('common.cancelOperation')
          })
        })
    },
    setUnBindDevice (params) {
      this.$confirm(
        this.$t('device.unBindDept'),
        this.$t('common.warningNotice'),
        {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          deviceApi
            .setEmployeeUnBindDevices(params)
            .then((data) => {
              if (data.code === '00000000') {
                this.getBindList()
              } else {
                this.errorMessage(data.message)
              }
            })
            .catch((data) => {
              this.errorMessage()
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('common.cancelOperation')
          })
        })
    },
    viewDevice (row) {
      this.$router.push({ name: 'deviceList', query: { sn: row.devSn } })
    },
    deleteDevice (row) {
      if (!this.employeeId) {
        if (this.currentEmp && this.currentEmp.id) {
          this.employeeId = this.currentEmp.id
        } else {
          return false
        }
      }
      let params = {
        deviceSn: [row.devSn],
        employeeId: [this.employeeId]
      }
      this.setUnBindDevice(params)
    }
  }
}
</script>
<style scoped lang="less">
@borderColor: rgba(128, 128, 128, 0.2);
.panel_cla1 {
  &:after {
    content: '';
    height: 0px;
    width: 0px;
    clear: both;
    display: block;
    overflow: hidden;
  }
}
.emp_info_cla {
  /deep/.el-form-item {
    display: flex;
  }
  margin-top: 12px;
  /deep/.el-form-item__label {
    width: 200px;
  }
  .kv_item_cla {
    width: 100%;
    // border-bottom: 1px solid @borderColor;
    margin: 5px 0;
  }
  .action_btn {
    cursor: pointer;
  }
  .active {
    color: #78bc27;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/enterpriseAdmin/enterpriseSetting/employee/employeeInfo.vue